// Модальное окно на нативном <dialog>: showModal/close, крестик в углу; на телефоне «Назад» закрывает окно
import { useEffect, useRef, type ReactNode } from 'react';
import { useBackClose } from '../lib/backClose';
import { Icon } from './Icon';

export interface DialogProps {
  id?: string;
  open: boolean;
  onClose: () => void;
  wide?: boolean;
  className?: string;
  children?: ReactNode;
}

export function Dialog({ id, open, onClose, wide, className, children }: DialogProps) {
  const ref = useRef<HTMLDialogElement>(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) {
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
    } else if (!open && d.open) {
      if (typeof d.close === 'function') d.close();
      else d.removeAttribute('open');
    }
  }, [open]);

  // Окно закрыли крестиком, Esc или снаружи (dialog.close()) — сообщаем владельцу
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    const h = () => onCloseRef.current();
    d.addEventListener('close', h);
    return () => d.removeEventListener('close', h);
  }, []);

  useBackClose(open, () => {
    const d = ref.current;
    if (d?.open && typeof d.close === 'function') d.close(); else onCloseRef.current();
  });

  const cls = ['dialog', wide ? 'wide' : '', className || ''].filter(Boolean).join(' ');
  return (
    <dialog id={id} ref={ref} className={cls}>
      <form method="dialog">
        <button className="close" aria-label="Закрыть"><Icon name="x" /></button>
      </form>
      {children}
    </dialog>
  );
}
